import * as React from "react";

function SvgShieldCheckDuo({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path d="M0 0h24v24H0z" />
        <path
          fill="#374151"
          d="M10.874 2.664a1.74 1.74 0 012.251 0 10.529 10.529 0 006.033 2.51 1.735 1.735 0 011.586 1.59l.006.149v4.33c0 4.707-3.384 9.092-8.023 10.406-.472.133-.98.133-1.453 0-4.547-1.287-7.888-5.525-8.02-10.125l-.004-.282v-4.33c0-.904.689-1.668 1.591-1.739a10.52 10.52 0 006.033-2.509z"
        />
        <path
          fill="#98DB69"
          d="M11.906 3.769a.24.24 0 01.243.034 12.024 12.024 0 006.892 2.866c.114.009.209.114.209.244v4.33l-.004.268c-.127 3.93-3.017 7.587-6.927 8.694a1.168 1.168 0 01-.637 0c-4-1.131-6.932-4.932-6.932-8.963v-4.33l.008-.062a.23.23 0 01.2-.181 12.02 12.02 0 006.6-2.624l.294-.243zm3.943 6.043a.749.749 0 00-1.06 0l-3.618 3.617-1.959-1.958-.084-.073a.748.748 0 00-.976 1.133l2.489 2.49.084.072c.293.218.71.194.976-.073l4.148-4.148.073-.084a.748.748 0 00-.073-.976z"
        />
      </g>
    </svg>
  );
}

export default SvgShieldCheckDuo;
